import { Badge } from '@/components/ui/badge.js';
import { getPersonFirstNameWithLastNameInitial } from '@airreading/common';
import { UserLike } from '@airreading/common/data';
import clsx from 'clsx';
import { ReactNode } from 'react';

export interface UserIdentifiable {
  id: string;
  user: UserLike;
}

export interface PeopleBadgeListProps {
  people: (UserIdentifiable | UserLike)[];
  wrap?: boolean;
  useFirstNameWithLastNameInitial?: boolean;
  horizontal?: boolean;
  testId?: string;
  renderExtra?: (person: UserLike) => ReactNode;
}

export function PeopleBadgeList({
  people,
  wrap = false,
  useFirstNameWithLastNameInitial = false,
  horizontal = false,
  testId,
  renderExtra,
}: PeopleBadgeListProps) {
  return (
    <div className={clsx(['flex', 'gap-1', horizontal ? 'flex-row' : wrap ? 'flex-wrap' : 'flex-col'])}>
      {people.map((person, index) => {
        const personObject = 'user' in person ? person.user : person;
        const extra = renderExtra?.(personObject);

        return (
          <Badge
            variant="outline"
            className={clsx([
              'text-left rounded-sm px-1',
              extra ? 'flex items-center gap-1' : '',
              horizontal ? 'w-auto' : 'w-fit',
            ])}
            key={person.id}
            data-testid={testId && (people.length === 1 ? testId : `${testId}-${index + 1}`)}
          >
            {useFirstNameWithLastNameInitial
              ? getPersonFirstNameWithLastNameInitial(personObject)
              : personObject.fullNameOrEmail}
            {extra}
          </Badge>
        );
      })}
    </div>
  );
}
